var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SaveQueryDialog", {
        ref: "saveQuery",
        attrs: { query: _vm.query, service: _vm.reportGenerator },
        on: {
          "update:query": function ($event) {
            return _vm.$emit("update:query", $event)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: {
            disabled: _vm.disabled,
            color: _vm.buttonLabel ? "success" : "",
          },
          on: {
            click: function ($event) {
              return _vm.saveQuery()
            },
          },
        },
        [
          _c(
            "v-icon",
            {
              staticClass: "mr-2",
              attrs: { color: _vm.buttonLabel ? "white" : "info" },
            },
            [_vm._v("save")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-capitalize" }, [
            _vm._v(_vm._s(_vm.buttonLabel || `${_vm.$t("Button.SaveAs")}..`)),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }